//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import navbar from '@/components/ui/navbar';
import cardbox from '@/components/ui/cardbox';
import tabbox from '@/components/ui/tabbox';
import loadmore from '@/components/ui/loadmore';

import mainMenuTab from "@/components/mainMenuTab";

export default {
    components: {mainMenuTab,cardbox,navbar,tabbox,loadmore},
    data(){
        return {
            tabData: [
                {label:'未使用',value: 1, active: true},
                {label:'已使用',value: 0, active: false},
                {label:'已过期',value: 2, active: false},
            ],
            coupon: {
                total: 0,
                page: 1,
                size: 50,
                data: []
            },
            currentTab: 1,
        }
    },
    methods:{

        // 切换tab
        changeTab(item,index){
            this.currentTab = item.value;
            this.queryCoupon();
        },

        // 查询优惠券
        queryCoupon(){

            const opts = {
                url: api.myCoupon,
                data: {
                    status: this.currentTab,
                    page: 1,
                    size: 100,
                },
                type: 'get'
            }
            common.query(opts).then(res=>{

                if(this.currentTab ==2 ){
                    this.coupon.data = [];
                    return;
                }

                this.coupon = res.data;

            },res=>{
                this.$vux.toast.text(res.message);
            });
        },


    },
    mounted(){

        this.queryCoupon();

    },
}




// WEBPACK FOOTER //
// ./src/views/member/coupon.vue